"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * [[RealtimeVolumeIndicator]] stores the current volume, mute, and
 * signal strength for an attendee.
 */
var RealtimeVolumeIndicator = /** @class */ (function () {
    function RealtimeVolumeIndicator() {
        this.volume = null;
        this.muted = null;
        this.signalStrength = null;
    }
    return RealtimeVolumeIndicator;
}());
exports.default = RealtimeVolumeIndicator;
//# sourceMappingURL=RealtimeVolumeIndicator.js.map